<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">รายชื่อลูกค้า</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายชื่อลูกค้า
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" class="">
            <v-text-field v-model="search" placeholder="ค้นหารายชื่อลูกค้า" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="disableTable === false">
          <v-col cols="12" class="pt-3">
            <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">แสดงรายชื่อลูกค้าทั้งหมด {{ countCustomer }} รายการ</span>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" v-if="disableTable === false" class="mt-2">
            <v-data-table
            :headers="headers"
            :items="customerList"
            :search="search"
            :page.sync="page"
            @pagination="showCountCustomer"
            no-results-text="ไม่พบรายชื่อลูกค้า"
            no-data-text="ไม่มีรายชื่อลูกค้าในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            class="elevation-1"
            >
              <template v-slot:[`item.manages`]="{ item }">
                <v-row>
                  <v-col col="12">
                    <v-btn class="d-inline-block" text rounded color="#27AB9C" :class="!MobileSize? 'px-2' : 'pa-0 ma-0'" small @click="gotoDetail(item)">
                      <v-icon small>mdi-file-document-outline</v-icon>
                      <span>รายละเอียด</span>
                    </v-btn>&nbsp;&nbsp;
                    <span class="d-inline-block" style="color: #F5222D; font-size: 12px;">{{ item.note_address }}</span>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายชื่อลูกค้า</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { Decode, Encode } from '@/services'
export default {
  components: {
  },
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',
      customerData: [],
      cus_id: '',
      // table
      disableTable: false,
      search: '',
      page: 1,
      itemsPerPage: 10,
      headers: [
        { text: 'รหัสลูกค้า', value: 'cus_code', sortable: false, width: '70px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', sortable: false, width: '190px', class: 'backgroundTable fontTable--text' },
        { text: 'กลุ่มลูกค้า', value: 'channel_name', sortable: false, width: '100px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', sortable: false, width: '220px', class: 'backgroundTable fontTable--text' }
        // { text: '', value: 'note_address', sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      customerList: [],
      countCustomer: ''
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/Order/SalesCustomerListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SalesCustomerList' }).catch(() => {})
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  async created () {
    this.$EventBus.$emit('enableCartGracz')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = this.userDetailSelling.seller_shop_id
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
        this.cus_id = this.customerData.cus_id
      }
      this.getCustomerList()
    }
    // console.log('userDetailSelling', this.userDetailSelling)
    // console.log('customerData', this.customerData)
    // console.log('seller_shop_id', this.seller_shop_id)
    // console.log('cus_id', this.cus_id)

    // this.$EventBus.$emit('changeNav')
    // window.addEventListener('storage', function (event) {
    //   if (event.key === 'oneData' && !event.newValue) {
    //     window.location.assign('/')
    //   }
    // })
    // if (localStorage.getItem('oneData') === null) {
    //   this.$router.push({ path: '/' }).catch(() => {})
    // } else {
    //   this.getCustomerList()
    // }
  },
  beforeDestroy () {
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/UserProfileMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/UserProfile' }).catch(() => {})
      }
    },
    gotoDetail (item) {
      localStorage.setItem('GrazcCustomerDetail', Encode.encode(item))
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SalesCustomerDetailMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SalesCustomerDetail' }).catch(() => {})
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === 'Fail to upload file.') {
        return ['ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ได้', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    async getCustomerList () {
      this.$store.commit('openLoader')
      var data = {
        seller_shop_id: this.seller_shop_id,
        cus_id: this.cus_id,
        page: 1
      }
      // console.log('data to API search', data)
      await this.$store.dispatch('actionsGraczListCustomerOfSales', data)
      var res = await this.$store.state.ModuleGraczCustomer.stateGraczListCustomerOfSales
      // console.log('res from List API', res)
      if (res.result === 'SUCCESS') {
        this.customerList = res.data.list_customer
        this.countCustomer = this.customerList.length
        if (this.countCustomer <= 0) {
          this.disableTable = true
        }
        this.$store.commit('closeLoader')
      } else {
        this.$store.commit('closeLoader')
        this.disableTable = true
        var msg = this.getErrorMsg(res.message)
        this.$swal.fire({ icon: 'error', title: msg, showConfirmButton: false, timer: 1500 })
      }
    },
    showCountCustomer (pagination) {
      this.countCustomer = pagination.itemsLength
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(4) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(1) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(4) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 11;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
</style>
